import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import utils from '../../../utils/utils.functions';
 
class ComponentToPrint extends React.Component {
  render() {
    const { data, suc } = this.props;
    return (
      <div style={{ padding: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10
        }}
      >
        <div>
          <div style={{ textAlign: "left" }}>
            <h3>Reporte total de ventas sucursales</h3>
          </div>
          <div style={{ textAlign: "left" }}>
            <small style={{ padding: 0 }}>Desde</small>
            <div>{moment(data.fecha).format('DD/MM/YYYY')}</div>
          </div>
        </div>
        <div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Generedo el</small>
            <div>{moment().format('DD/MM/YYYY H:m:s')}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Sucursales seleccionadas</small>
            <div>{suc}</div>
          </div>
        </div>
      </div>
      
      <div style={{ width: "100%", textAlign: "left", marginTop: 10, marginBottom: 10 }}>
        Sucursales dividos por tipo de envio:
      </div>
      
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        {data.totalSucursales.map((suc, i) => {
          return <div
          key={i}
          style={{
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 10
          }}
        >
          <div>SUCURSAL {suc.sucursal.description.toUpperCase()} - {suc.tipos.description.toUpperCase()}</div>
          <div>{utils.formatMoney(suc.total_amount)}CLP</div>
        </div>
        })}   
      </div>

      <div style={{ width: "100%", textAlign: "left", marginTop: 10, marginBottom: 10 }}>
        Totales:
      </div>
      
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          border: "1px solid #ccc",
          padding: 10,
          marginTop: 3
        }}
      >
        {data.totalSucursalesGeneral.map((totales) => {
          return <div
          style={{
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 10
          }}
        >
          <div>SUCURSAL {totales.sucursal.description.toUpperCase()}</div>
          <div>{utils.formatMoney(totales.total_amount)}CLP</div>
        </div>
        })}
      </div>
    </div>
    );
  }
}
 
const PrinterCaja = ({ data, suc }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint data={data} suc={suc} ref={componentRef} />
      </div>
      <button onClick={handlePrint} type="button" className="btnx btnx-warn mr-1">Imprimir reporte</button>
    </div>
  );
};

export default PrinterCaja;